// modules/NavLink.js
import React from 'react'
import { Link } from 'react-router'

export default React.createClass({
  render() {
    return <Link {...this.props} activeClassName="selected"/>
  }
})


// WEBPACK FOOTER //
// ./src/components/NavLink.js